// src/styles/theme.js
export const theme = {
  colors: {
    primary: '#C8A882',
    primaryDark: '#B8956C',
    secondary: '#2A2A2A',
    accent: '#8B7355',
    dark: '#1A1A1A',
    light: '#F8F6F3',
    white: '#FFFFFF',
    gray: '#666666',
    lightGray: '#E8E8E8',
    cream: '#F5F3F0'
  },
  
  gradients: {
    primary: 'linear-gradient(135deg, #C8A882 0%, #B8956C 100%)',
    dark: 'linear-gradient(135deg, #2A2A2A 0%, #1A1A1A 100%)',
    overlay: 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6))'
  },
  
  fonts: {
    primary: "'Playfair Display', serif",
    secondary: "'Inter', sans-serif"
  },
  
  shadows: {
    small: '0 2px 8px rgba(0,0,0,0.08)',
    medium: '0 4px 16px rgba(0,0,0,0.12)',
    large: '0 8px 32px rgba(0,0,0,0.16)',
    xl: '0 16px 64px rgba(0,0,0,0.2)'
  },
  
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    xl: '20px'
  },
  
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    xl: '1400px'
  }
};